import {
    List,
    ListItem,
    Typography,
    ListItemSecondaryAction,
    Paper,
    Divider,
    ListItemIcon,
    Box,
    Button,
    Grid,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { ContentContainer } from '../ContentContainer';
import EditIcon from '@mui/icons-material/Edit';
import { DeviceDetailsProvider , useDeviceDetails} from '../../data/DataProviders/DeviceDetailsProvider';
import { isDataLoaded, Status } from '../../types';
import { AppRoute } from '../../routes';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import { StatusTag } from '../StatusTag/StatusTag';
import {DevicePropertiesDetails, SierraDeviceData, Uart } from '../../types/device';
import { FX30_ETHERNET, FX30S_SERIAL } from '../../constants';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import deviceStyles from '../../app/device-management/DeviceStyle';
import * as PXBColors from '@brightlayer-ui/colors';
import { DeleteForever } from '@mui/icons-material';
import { LabelWithSubTitle } from '../LabelWithSubTitle/LabelWithSubtitle';
import { NavigationHeader } from '../NavigationHeader/NavigationHeader';
import { ChildDeviceList } from './ChildDeviceList';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { standard, parity } from '../../constants/device-data';
import { DeleteGatewayModal } from './DeleteGatewayModal';
import { DeleteConfirmModal } from '../CommonDeleteModals/DeleteConfirmModal';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { Thunks,Actions } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../selectors';
import { SignalRSiteDataProvider, useSignalRSiteData } from '../../data/DataProviders/SignalRSiteDataProvider';
import _ from 'lodash';

export const DeviceProfileData: React.FC<{
    backAppRoute: AppRoute;
    data: SierraDeviceData | null;
    deviceTypeList: any[];
}> = (props) => {
    const currentAppRoute = useCurrentAppRoute();
    const classes = deviceStyles();
    const history = useHistory();
    const { addToast } = useToasts();
    const [gatewayDeviceInfo, setGatewayDeviceInfo] = useState<SierraDeviceData | null>(null);
    const [deviceStatus, setDeviceStatus] = React.useState<boolean | null >();
    const [siteName, setSiteName] = useState('');
    const [netmask, setNetMask] = useState('');
    const [uart, setUart] = useState<Uart | null>(null);
    const [std, setStd] = useState('');
    const [par, setPar] = useState('');
    const [open, setOpen] = React.useState(false);
    const [openConfirm, setOpenConfirm] = React.useState(false);
    const authHelper = useAuthHelper();
    const dispatch = useDispatch();
    const deviceState = useSelector(Selectors.SierraDevice.deviceRegistration);
    const devicePropertiesData = useDeviceDetails();
    const realTimeSiteData = useSignalRSiteData();
    
    const navigateToSiteProfile = (): void => {
        if (currentAppRoute.type === 'DeviceProfile')
            pushAppRoute(history, {
                type: 'SiteProfile',
                orgId: currentAppRoute.orgId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            });
            dispatch(Actions.SierraDevices.sierraChildDeviceRegistrationUnmounted());
    };

    React.useEffect(() => {
        if (deviceState.deleteSuccess) {
            if(gatewayDeviceInfo && gatewayDeviceInfo.name){
                addToast(`${gatewayDeviceInfo.name} deleted successfully`);
            }
            navigateToSiteProfile();
           }
    }, [deviceState.deleteSuccess]);


    useEffect(() => {
        if (props.data) {
            setGatewayDeviceInfo(props.data);
            const value: any = props.data.configTreeJson;
            if (value) {
                const data: any = value.gatewayDevice;
                setNetMask(data.ethernet.netmask);
                setUart(data.uart1);
                const recordStandard: { key: string; value: string } | undefined = standard.find(
                    (item: { key: string; value: string }) => item.key === data.uart1.std
                );

                const stdValue = recordStandard !== undefined ? recordStandard.value : '';
                setStd(stdValue);
                const recordParity: { key: string; value: string } | undefined = parity.find(
                    (item: { key: string; value: string }) => item.key === data.uart1.pair
                );

                const parValue = recordParity !== undefined ? recordParity.value : '';
                setPar(parValue);
            }
        }
    }, [props.data]);

    useEffect(() => { 
          if( isDataLoaded(devicePropertiesData)) {
            setDeviceStatus(devicePropertiesData.value.status);
            setSiteName(devicePropertiesData.value.siteName || '');
           } 
   }, [devicePropertiesData]); 

    useEffect(() => {
        if(realTimeSiteData && realTimeSiteData.devices) {
            if( isDataLoaded(devicePropertiesData)) {
            const updatedDeviceStatus =  _.find(realTimeSiteData.devices, {
                    deviceId: devicePropertiesData.value.id
            });
             if(updatedDeviceStatus){
                  setDeviceStatus(updatedDeviceStatus.status);
                  setSiteName(devicePropertiesData.value.siteName || '');
                }  
            }          
        }     

      }, [realTimeSiteData]); 

    const getDeviceInfo = (deviceData: DevicePropertiesDetails): void => {

        if (deviceData) {
                setDeviceStatus(deviceData.status);
                setSiteName(deviceData.siteName || '');
        }
     };

    const handleClose = (): void => {
        setOpen(false);
    };

    const handleDelete = (): void => {
        handleClose();
        if(gatewayDeviceInfo)
         dispatch(Thunks.SierraDevice.DeleteDevice([gatewayDeviceInfo.pxWhiteGatewayId],authHelper,addToast));
    };


    const handleConfirmClose = (): void => {
        setOpenConfirm(false);
    }

    const onContinue = (): void => {
        setOpen(false);
        setOpenConfirm(true);
    }


    const navigateToEditDevice = (): void => {
        if (gatewayDeviceInfo && currentAppRoute.type === 'DeviceProfile') {
            pushAppRoute(history, {
                type: 'EditConnectedDevice',
                deviceId: currentAppRoute.deviceId,
                locationId: currentAppRoute.locationId,
                orgId: currentAppRoute.orgId,
                siteId: currentAppRoute.siteId,
            });
        } else addToast('This Device does not have any editable fields', 'error', 'Warning');
    };
    const onDelete = (): void => {
        // addToast(
        //     'Deleting a Device is not currently supported through the Brightlayer Industrial UI. If you need to delete a Device, please reach out to Brightlayer Support.',
        //     'error',
        //     'Information'
        // );
        setOpen(true);
    };

    return (
        <>
            <ContentContainer>
                {props.data && currentAppRoute.type === 'DeviceProfile' && gatewayDeviceInfo && (
                    <>
                        <NavigationHeader
                            for="Connected Device"
                            siteName={siteName}
                            connectedDevice={gatewayDeviceInfo.name || ''}
                            device={''}
                        />

                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <Paper>
                                    <List>
                                        <ListItem data-testid="device-name">
                                            <Typography variant="h6" color="primary">
                                                {gatewayDeviceInfo.name}
                                            </Typography>

                                            <ListItemSecondaryAction>
                                                <ListItemIcon data-testid="device-status-icon" style = {{ display: 'block' }}>
                                                    {deviceStatus ? (
                                                        <StatusTag status={Status.Online} style={{ marginRight: 30 }} />
                                                    ) : (
                                                        <StatusTag
                                                            status={Status.Offline}
                                                            style={{ marginRight: 30 }}
                                                        />
                                                    )}
                                                </ListItemIcon>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                        <ListItem data-testid="device-type" className={classes.margin8}>
                                            <LabelWithSubTitle
                                                title={gatewayDeviceInfo.model}
                                                subTitle="Connected Device Type"
                                            />
                                        </ListItem>
                                        <Divider />
                                        <ListItem data-testid="child-device-type-list" className={classes.margin8}>
                                            <Box>
                                                {props.deviceTypeList.map((deviceData) => (
                                                    <Typography
                                                        key={deviceData.key}
                                                        variant="body2"
                                                        display="block"
                                                        style={{ fontWeight: 600 }}
                                                    >
                                                        {deviceData.value.displayName}
                                                    </Typography>
                                                ))}

                                                <LabelWithSubTitle subTitle="Supported Device Types" />
                                            </Box>
                                        </ListItem>
                                        <Divider />
                                        <ListItem data-testid="serial-number" className={classes.margin8}>
                                            <LabelWithSubTitle
                                                title={gatewayDeviceInfo.serialNumber}
                                                subTitle="Serial Number"
                                            />
                                        </ListItem>
                                        <Divider />
                                        <ListItem data-testid="imei" className={classes.margin8}>
                                            <LabelWithSubTitle title={gatewayDeviceInfo.imei} subTitle="IMEI" />
                                        </ListItem>

                                        <Divider />
                                        {gatewayDeviceInfo.model.toLowerCase() === FX30_ETHERNET && (
                                            <>
                                                <ListItem data-testid="ip-address" className={classes.margin8}>
                                                    <LabelWithSubTitle
                                                        title={gatewayDeviceInfo.ipAddress}
                                                        subTitle="Modbus (TCP/IP) Address"
                                                    />
                                                </ListItem>
                                                <Divider />
                                                <ListItem data-testid="net-mask" className={classes.margin8}>
                                                    <LabelWithSubTitle title={netmask} subTitle="Netmask" />
                                                </ListItem>
                                            </>
                                        )}
                                        {gatewayDeviceInfo.model.toLowerCase() === FX30S_SERIAL && uart && (
                                            <>
                                                <ListItem data-testid="baud-rate" className={classes.margin8}>
                                                    <LabelWithSubTitle title={uart.baud} subTitle="Baud Rate" />
                                                </ListItem>
                                                <Divider />
                                                <ListItem data-testid="data-bits" className={classes.margin8}>
                                                    <LabelWithSubTitle title={uart.bits} subTitle="Databits" />
                                                </ListItem>
                                                <Divider />
                                                <ListItem data-testid="flow" className={classes.margin8}>
                                                    <LabelWithSubTitle title={uart.flow} subTitle="Flow" />
                                                </ListItem>
                                                <Divider />
                                                <ListItem data-testid="parity" className={classes.margin8}>
                                                    <LabelWithSubTitle title={par} subTitle="Parity" />
                                                </ListItem>
                                                <Divider />
                                                <ListItem data-testid="stop-bits" className={classes.margin8}>
                                                    <LabelWithSubTitle title={uart.stop} subTitle="Stop Bits" />
                                                </ListItem>
                                                <Divider />
                                                <ListItem data-testid="standard" className={classes.margin8}>
                                                    <LabelWithSubTitle title={std} subTitle="Standard" />
                                                </ListItem>
                                                <Divider />
                                                <ListItem
                                                    data-testid="terminating-resistor-support"
                                                    className={classes.margin8}
                                                >
                                                    <LabelWithSubTitle
                                                        title={uart.term}
                                                        subTitle="Terminating Resistor Support"
                                                    />
                                                </ListItem>
                                            </>
                                        )}
                                        <Divider />

                                        <div
                                            style={{
                                                margin: 16,
                                                display: 'flex',
                                                justifyContent: 'space-evenly',
                                            }}
                                        >
                                            <Box>
                                                <Button
                                                    style={{ marginRight: 15 }}
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<EditIcon />}
                                                    data-testid="edit-action"
                                                    onClick={navigateToEditDevice}
                                                >
                                                    Edit Connected Device
                                                </Button>
                                            </Box>
                                            <Box>
                                                <Button
                                                    style={{
                                                        color: PXBColors.red[500],
                                                        borderColor: PXBColors.gray[100],
                                                    }}
                                                    variant="outlined"
                                                    startIcon={<DeleteForever />}
                                                    data-testid="delete-action"
                                                    onClick={(): void => {
                                                        onDelete();
                                                    }}
                                                >
                                                    Delete Forever
                                                </Button>
                                            </Box>
                                        </div>
                                    </List>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <DataProviderCache for={'device-details'}>
                                    <DeviceDetailsProvider deviceId={props.data.pxWhiteGatewayId} recursive={true}>
                                    <SignalRSiteDataProvider siteId={currentAppRoute.siteId} locationId={currentAppRoute.locationId}>                   
                                        <ChildDeviceList deviceDetails={getDeviceInfo} />
                                        <DeleteGatewayModal
                                            open={open}
                                            onClose={handleClose}
                                            handleContinue={onContinue}
                                            name={gatewayDeviceInfo.name}
                                        />
                                        <DeleteConfirmModal
                                            open={openConfirm}
                                            onClose={handleConfirmClose}
                                            name={gatewayDeviceInfo.name}
                                            handleDelete={handleDelete}
                                            navigateFn={navigateToSiteProfile}
                                        />
                                    </SignalRSiteDataProvider>
                                    </DeviceDetailsProvider>
                                </DataProviderCache>
                            </Grid>
                        </Grid>
                    </>
                )}
            </ContentContainer>
        </>
    )
}
